import { ImageProps } from '@interfaces';
import { Main } from './styles';

const Image: React.FC<ImageProps> = ({ src, alt, maxHeight, objectFit }: ImageProps) => {
    return (
        <Main maxHeight={maxHeight} objectFit={objectFit}>
            <div className="WrapAnchorPicture">
                <div className="AnchorPicture">
                    <div className="WrapPicture">
                        <picture>
                            <img
                                src={src}
                                alt={alt}
                            />
                        </picture>

                    </div>
                </div>
            </div>
        </Main>
    );
};

export { Image };
